const $ = jQuery

function isOnScreen (elem, offsetBottom = 0, offsetTop = 0) {
  if (elem.length === 0) return
  const viewportTop = $(window).scrollTop() + offsetTop
  const viewportHeight = $(window).height() - offsetBottom
  const viewportBottom = viewportTop + viewportHeight
  const top = $(elem).offset().top
  const height = $(elem).height()
  const bottom = top + height

  return (
    (top >= viewportTop && top < viewportBottom) ||
    (bottom > viewportTop && bottom <= viewportBottom) ||
    (height > viewportHeight && top <= viewportTop && bottom >= viewportBottom)
  )
}

module.exports = {
  isOnScreen
}